import MainLayout from '@/layout/MainLayout.vue'
import AuditList from '@/pages/audit/audit/Index.vue'
import AuditSingle from '@/pages/audit/audit/single/AuditSingle.vue'
import AuditGeneralInfo from '@/pages/audit/audit/single/tabs/general-info/GeneralInfo.vue'
import AuditFlawList from '@/pages/audit/audit/single/tabs/flaws/FlawList.vue'
import AuditAttachments from '@/pages/audit/audit/single/tabs/Attachments.vue'
import AuditHistory from '@/pages/audit/audit/single/tabs/History.vue'
import PlanList from '@/pages/audit/plans/Index.vue'
import PlanSingle from '@/pages/audit/plans/single/PlanSingle.vue'
import RecommendationList from '@/pages/audit/recommendations/RecommendationList.vue'

export default [
  {
    path: '/audit-section',
    name: 'audit-section',
    component: MainLayout,
    redirect: { name: 'plan-list' },
    meta: {
      title: 'Аудит',
    },
    children: [
      {
        path: '/plans',
        name: 'plan-list',
        component: PlanList,
        meta: {
          title: 'Плани',
        },
        children: [
          {
            path: ':id',
            name: 'plan-single',
            component: PlanSingle,
            meta: {
              title: 'План',
            },
          },
        ],
      },
      {
        path: '/audit',
        name: 'audit-list',
        component: AuditList,
        meta: {
          title: 'Аудит',
          resource: 'audits',
        },
        children: [
          {
            path: ':id',
            name: 'audit-single',
            component: AuditSingle,
            meta: {
              title: 'Аудит',
              tabList: true,
            },
            redirect: { name: 'audit-general-info' },
            children: [
              {
                path: 'general-info',
                name: 'audit-general-info',
                component: AuditGeneralInfo,
                meta: {
                  title: 'Основне',
                },
              },
              {
                path: 'flaws',
                name: 'audit-flaws',
                component: AuditFlawList,
                meta: {
                  title: 'Факти недоліків',
                },
              },
              {
                path: 'attachments',
                name: 'audit-attachments',
                component: AuditAttachments,
                meta: {
                  title: 'Вкладення',
                },
              },
              {
                path: 'history',
                name: 'audit-history',
                component: AuditHistory,
                meta: {
                  title: 'Історія змін',
                },
              },
            ],
          },
        ],
      },
      {
        path: '/recommendations',
        name: 'recommendation-list',
        component: RecommendationList,
        meta: {
          title: 'Рекомендації',
        },
      },
      {
        path: '',
        redirect: { name: 'plan-list' },
      },
    ],
  },
]
